export default [
  { path: '/octopus/OctopusSupplierConfig', name: 'OctopusSupplierConfig', component: resolve => require(['@/views/octopus/OctopusSupplierConfig'], resolve)}
]



// WEBPACK FOOTER //
// ./src/config/router/octopus.js